import Grid, { type GridProps } from '@mui/material/Grid';
import Skeleton from '@mui/material/Skeleton';
import { type ReactNode } from 'react';

import { useBreakpoint } from '../../hooks/useBreakpoint/useBreakpoint';
import { Typography } from '../Typography/Typography';

type Props = Omit<GridProps, 'children' | 'size'> & {
  title?: ReactNode;
  children: ReactNode;
  colSpan?: number;
  isLoading?: boolean;
  size?: GridProps['size'];
  variant?: 'primary' | 'emphasis';
  'data-testid'?: string;
};

export const DataDisplayItem = ({ title, children, colSpan, isLoading, size, variant = 'primary', ...rest }: Props) => {
  const { isMobile } = useBreakpoint();

  const defaultColSpan = isMobile ? 6 : 4;

  return (
    <Grid
      size={size ?? colSpan ?? defaultColSpan}
      {...rest}
      sx={[
        {
          display: 'flex',
          flexDirection: 'column',
          gap: 1,
        },
        ...(Array.isArray(rest.sx) ? rest.sx : [rest.sx]),
      ]}
    >
      {isLoading ? <Skeleton height={40} width="100%" /> : null}
      {title ? (
        <Typography
          variant={variant === 'emphasis' ? 'h5' : 'caption'}
          color={variant === 'emphasis' ? 'default' : 'secondary'}
          sx={{ textAlign: variant === 'emphasis' ? 'center' : 'left' }}
        >
          {title}
        </Typography>
      ) : null}
      {typeof children === 'string' || typeof children === 'number' ? (
        <Typography
          variant="body2"
          color="default"
          component="div"
          sx={{ textAlign: variant === 'emphasis' ? 'center' : 'left' }}
        >
          {children}
        </Typography>
      ) : (
        children
      )}
    </Grid>
  );
};
